import { useCallback } from 'react'
import { usePartnerId } from 'utils/routing/params.hooks'
import {
  usePartnerSandboxOrderSimulateEventMutation,
  FetchPartnerSandboxOrderDocument,
} from 'domains/connect/api'

export interface SimulateSandboxOrderEventMutationProps {
  simulationEvent: string
  simulationEventArgs: string[]
  callbackEvent?: string
}

export const usePartnerSandboxOrderSimulateEvent = (orderId: string) => {
  const partnerId = usePartnerId()
  const [triggerMutation, { data, loading, error }] = usePartnerSandboxOrderSimulateEventMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      { query: FetchPartnerSandboxOrderDocument, variables: { orderId, partnerId } },
    ],
  })

  const simulateSandboxOrderEvent = useCallback(
    (args: SimulateSandboxOrderEventMutationProps) =>
      triggerMutation({ variables: { orderId, partnerId, ...args } }),
    [triggerMutation, orderId, partnerId]
  )

  return {
    simulateSandboxOrderEvent,
    loading,
    error,
  }
}
